import PageTitle from '../../components/PageTitle';
import PageContent from '../../components/PageContent';

function Support() {
  return (<>
    <PageTitle>
      Support     
    </PageTitle>
    <PageContent>
        <div className="row">
          <div className="col-12">
            {/* <div className="row"> */}

             <div id="sponsorText">
             <h3>Sponsorship</h3>         
              <p>Become a sponsor of Spotlight Players!</p>
              <p>Spotlight Players is a 501(c)3 nonprofit, community theater company. Last season was a great success! Over 8000 people from the Plymouth-Canton area and surrounding Southeast Michigan enjoyed themselves at a Spotlight Players performance.</p>
            
            
                <div className="donateButtons">
                    {/* <h2 className="section-title text-white">Sponsorship Flyer</h2> */}
                    <a href="https://drive.google.com/drive/folders/1kGBrK7sVEGzgi3GSm8r6xeFqaYJ7tu51?usp=sharing" target={'_blank'} className="btn">View Flyer</a>
                    <img src="https://images.ctfassets.net/ae4cmm9kc6vt/vm1dfjM0XgoywBeoslgDD/f261a0f60e32b6cb199be769876c351e/Sponsorship_Flyer_2025-26.png?h=250"></img>

              
                </div>
              </div>
          
            {/* </div> */}
            <p>
              If you are interested in becoming a <strong>Sponsor</strong>, Please{" "}
              <a href="https://drive.google.com/drive/folders/1kGBrK7sVEGzgi3GSm8r6xeFqaYJ7tu51?usp=sharing">
                CLICK HERE
              </a>
              <br></br>
              If you are interested in becoming a <strong>Donor</strong>, Please{" "}
              <a href="https://drive.google.com/drive/folders/13MAYiqBAjf9AGODFNsw2N7lytT0RMiCY?usp=sharing">
                CLICK HERE
              </a>
            </p>
            <p>Contact <a href='mailto:spotlightplayers.board@gmail.com'>spotlightplayers.board@gmail.com</a> for more information about sponsorship, ad dimensions, etc.</p>
            <p>If you wish to make a direct donation instead, please click below! We are grateful for your support!</p>
            
            <div className='donateButtons'>
              <a className='btn btn-primary btn-center' href="https://www.paypal.com/donate/?hosted_button_id=MRF3C63TX4EYA" target={'_blank'}>Donate via PayPal or Credit Card</a>
            </div>
            <div className='donateButtons'>
            <a className='btn btn-primary btn-center' href="https://account.venmo.com/payment-link?audience=private&recipients=%2CSpotlight-Players-of-Michigan&txn=pay" target={'_blank'}>Donate via Venmo</a>
            </div>
          

            <hr></hr>
            <h3>Kroger Community Rewards Program</h3>
            <p>If you are a Kroger shopper, please take a moment to either renew your enrollment with Spotlight Players Community Rewards or sign-up for enrollment.</p>
            <p>All you need to do is create an account (if a first-timer) and then select to enroll Spotlight Players to receive a percentage to be donated by Kroger every time you shop!</p>
            <p>Link to <a href="https://www.kroger.com/communityrewards">Kroger Community Rewards</a></p>
            <p>Enrollment is used by entering your <strong>phone number</strong> or <strong>plus card number</strong> that is associated with your account. Download detailed instructions <a href='https://drive.google.com/file/d/1QGUurtkFeF1KNiSz41W-d0sw071YQBt3/view?usp=sharing' target={'_blank'}>here</a>.</p>
            <p>Also, please be sure to pass this on to your friends or other theatre production cast/crew to help raise money for our productions! Thanks</p>

            <hr></hr>
            <h3>Amazon Wish List</h3>
            <p>Spotlight Players often uses Amazon to buy a multitude of different things. From name tags for auditions, to raffle tickets for 50/50, to props, and costumes, there are a lot of things that we are always looking for and could use help to keep the price of membership down.</p>
            <p>Please visit our <a href="https://a.co/hwHjpGT" target={'_blank'}>Amazon Wish list</a> to view current items we are trying to add to our inventory.</p>
          
            {/* <hr></hr>
            <h3>Advertise in our programs</h3>
            <p>It is great to support local businesses by having their ads in our programs. Please stay tuned for our upcoming season/show pricing.</p> */}
          </div>
        </div>
    </PageContent>    
  </>);
}

export default Support